import { useMemo } from "react";
import { useFetch } from "utils/use-fetch";

export const usePlayerApi = (playerConfiguration, video) => {
    const channelId = useMemo(() => {
        const urlElements = window.location.pathname.split('/');
        return urlElements[urlElements.indexOf('channel') + 1] || video.channels[0]?.id;
    }, [video]);

    const { playerDefinitionId: playerId, playerApiDomain } = playerConfiguration;
    const urlToken = video.playerToken ? `&token=${video.playerToken}` : '';
    const playerApiUrl = `https://${playerApiDomain}/play/player/${playerId}/video/${video.id}?channel-id=${channelId}${urlToken}`;

    const fetch = useFetch(playerApiUrl);

    return fetch;
}